import {flushAmplitude} from "./init_amplitude";

let isPageLeaveFlushInitialized = false;

export const initAmplitudePageLeaveFlush = (): void => {
    if (typeof document === "undefined" || typeof window === "undefined") {
        return;
    }

    if (isPageLeaveFlushInitialized) {
        return;
    }

    isPageLeaveFlushInitialized = true;

    const flushOnPageLeave = () => {
        void flushAmplitude();
    };

    window.addEventListener("pagehide", flushOnPageLeave);
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
            flushOnPageLeave();
        }
    });
};
import {flushAmplitude} from "./init_amplitude";

let isPageLeaveFlushInitialized = false;

export const initAmplitudePageLeaveFlush = (): void => {
    if (typeof document === "undefined" || typeof window === "undefined") {
        return;
    }

    if (isPageLeaveFlushInitialized) {
        return;
    }

    isPageLeaveFlushInitialized = true;

    const flushOnPageLeave = () => {
        void flushAmplitude();
    };

    window.addEventListener("pagehide", flushOnPageLeave);
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
            flushOnPageLeave();
        }
    });
};
